import React from 'react';

import { useTranslation } from 'react-i18next';
import defaultTheme from 'styles/theme';
import useWindowDimensions from 'hooks/window-dimensions';

import Spacer from 'components/Spacer';
import CardContact from 'components/CardContact';

import * as S from './styles';

function JoinUs() {
  const { t: translator } = useTranslation();

  const { width } = useWindowDimensions();
  const { hd } = defaultTheme.screensSize;

  return (
    <S.Container>
      <Spacer height={width < hd ? 40 : 80} />

      <CardContact title={translator('contactUs.joinUs.title')} text={translator('contactUs.joinUs.text')} />

      <Spacer height={width < hd ? 40 : 80} />
    </S.Container>
  );
}

export default JoinUs;
